
import link from './doughnut-text-inside.link';

export default function doughnutTextInside () {
	return {
		restrict:'E',
		scope: {
			config: '='
		},
		template: '<canvas></canvas>',
		replace: true,
		link
	};
};

doughnutTextInside.$inject = [];



// WEBPACK FOOTER //
// ./src/directive/doughnut-text-inside/doughnut-text-inside.js